import { forwardRef } from 'react';
import { Form } from 'react-bootstrap';

export const SCRAP_NFE_REQUIRED_MESSAGE =
  'O preenchimento do número da NF é obrigatório para concluir o scrap.';

export function sanitizeInvoiceNumbers(value: string): string[] {
  const numbers = new Set<string>();

  value
    .split(',')
    .map((part) => part.replace(/\D/g, ''))
    .filter(Boolean)
    .forEach((number) => numbers.add(number));

  return Array.from(numbers);
}

export function appendInvoiceNumbers(formData: FormData, value: string): string[] {
  const numbers = sanitizeInvoiceNumbers(value);
  numbers.forEach((number) => formData.append('invoice_numbers', number));
  return numbers;
}

interface ScrapNfeNumberInputProps {
  value: string;
  onChange: (value: string) => void;
  error: boolean;
}

export const ScrapNfeNumberInput = forwardRef<
  HTMLInputElement,
  ScrapNfeNumberInputProps
>(({ value, onChange, error }, ref) => (
  <Form.Group controlId="scrap-nfe-numbers">
    <Form.Label>
      Número da(s) NF(s) <span className="text-danger">*</span>
    </Form.Label>
    <Form.Control
      ref={ref}
      type="text"
      value={value}
      isInvalid={error}
      aria-label="Número da(s) NF(s)"
      onChange={(event) => onChange(event.target.value)}
    />
    <Form.Control.Feedback type="invalid">
      {SCRAP_NFE_REQUIRED_MESSAGE}
    </Form.Control.Feedback>
  </Form.Group>
));

ScrapNfeNumberInput.displayName = 'ScrapNfeNumberInput';
